import React from 'react';
import '../../../styles/modes/customMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Custom Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Manually create your own TSP tour by selecting points in the order you want to visit them. Apply your domain knowledge and routing intuition to design custom solutions.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>At least 3 location points set up in Setup Mode</li>
            <li>Start point designated (automatically added as first point)</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Start Tour Building:</strong>
              <ul>
                <li>Start point is automatically added as the first point</li>
                <li>Remaining points shown in Available Points list</li>
              </ul>
            </li>
            <li><strong>Select Points in Order:</strong>
              <ul>
                <li>Click on points from Available Points list</li>
                <li>Or click directly on point markers on the map</li>
                <li>Each selected point is added to your tour sequence</li>
                <li>Path is drawn on map in real-time</li>
              </ul>
            </li>
            <li><strong>View Path Information:</strong>
              <ul>
                <li><strong>Path Sequence:</strong> Shows current tour order</li>
                <li><strong>Path Distance:</strong> Total tour length updates in real-time</li>
                <li>Visual feedback as you build the route</li>
              </ul>
            </li>
            <li><strong>Modify Path:</strong>
              <ul>
                <li>Click "Undo Last Step" to remove last selected point</li>
                <li>Point returns to Available Points list</li>
                <li>Can rebuild path from that point</li>
              </ul>
            </li>
            <li><strong>Complete Tour:</strong>
              <ul>
                <li>Select all points to visit every location</li>
                <li>System automatically closes tour (returns to start)</li>
                <li>Click "Confirm Path" to save the tour</li>
              </ul>
            </li>
            <li><strong>Reset Path:</strong>
              <ul>
                <li>Click "Reset Path" to start over</li>
                <li>Returns to initial state with start point only</li>
              </ul>
            </li>
          </ol>

          <p><strong>Path Building Features:</strong></p>
          <ul>
            <li><strong>Interactive Selection:</strong> Click points on map or from list</li>
            <li><strong>Real-time Distance:</strong> See total distance update as you build</li>
            <li><strong>Visual Feedback:</strong> Path connections drawn immediately</li>
            <li><strong>Undo Functionality:</strong> Easily correct mistakes</li>
            <li><strong>Auto Closure:</strong> Tour automatically returns to start point</li>
          </ul>

          <p><strong>Routing Strategies:</strong></p>
          <ul>
            <li><strong>Nearest Neighbor Approach:</strong> Always visit closest unvisited point</li>
            <li><strong>Cluster-based Routing:</strong> Group nearby points and visit together</li>
            <li><strong>Geographic Sweep:</strong> Visit points in a circular pattern</li>
            <li><strong>Avoid Crossings:</strong> Crossing paths usually indicate inefficiency</li>
          </ul>

          <p><strong>Tips for Efficient Tours:</strong></p>
          <ul>
            <li>Start with closest point from depot</li>
            <li>Avoid creating path crossings when possible</li>
            <li>Look for natural clusters of nearby points</li>
            <li>Aim for smooth, circular tour patterns</li>
            <li>Compare with algorithm solution to learn optimization techniques</li>
            <li>Use Undo if you realize a better sequence</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 